import { createSlice } from '@reduxjs/toolkit'

export const OrderSlice = createSlice({
  name: 'order',
  initialState: {
    fetching: false,
    orders: [],
    error: null,
  },
  reducers: {
    orderRequest: (state) => ({ ...state, fetching: true, error: null }),
    orderRequestSuccess: (state, { payload }) => ({
      ...state, orders: payload, fetching: false, error: null,
    }),
    orderRequestFailed: (state, { payload }) => ({ ...state, fetching: false, error: payload }),
  },
})

export const {
  orderRequest, orderRequestSuccess,
  orderRequestFailed,
} = OrderSlice.actions
export default OrderSlice.reducer
